export const routesFlat = {
  admin: "/admin",
  adminNewsEdit: "/news/edit",
  adminNewsDisplay: "/news/view",
  notFound: "*",
};

export const tagsList = [
  { display: "Blog", be: "blog" },
  { display: "Event", be: "event" },
  { display: "Press Release", be: "press_release" },
  { display: "In The News", be: "news" },
  { display: "Webinar", be: "webinar" },
  { display: "Special Event", be: "special_event" },
  { display: "Land Carbon", be: "land_carbon" },
  { display: "Activity Data", be: "activity_data" },
  { display: "JMRV", be: "jmrv" },
  { display: "LUCA", be: "luca" },
  { display: "Tree Level", be: "tree_level" },
];
